export default {
  aboutapp: {
    subtitle: "About Us",
    title: "Welcome To Organic Agriculture Grocery Shop",

    desc:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",

    li1: "Organic products who are so",
    li2: "Healthy food everyday",
    li3: "Local growth of fresh food",
    li4: "Demoralized charms of pleasure",

    cta: "Start Using Mahal Today",

    quote:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered.",
    author: "Robart Day",
  },
};